import { render, staticRenderFns } from "./patientPage.vue?vue&type=template&id=70db1b8d&scoped=true"
import script from "./patientPage.vue?vue&type=script&lang=js"
export * from "./patientPage.vue?vue&type=script&lang=js"
import style0 from "./patientPage.vue?vue&type=style&index=0&id=70db1b8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db1b8d",
  null
  
)

export default component.exports